export const safeParseJson = (value, fallback = {}) => {
  if (value == null || value === "") return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const ensureArray = (value, fallback = []) => {
  if (Array.isArray(value)) return value;
  return fallback;
};

export const sanitizeString = (value, fallback = "") => {
  if (typeof value !== "string") return fallback;
  const trimmed = value.trim();
  return trimmed ? trimmed : fallback;
};

export const sanitizeAccountUid = (value) => {
  const candidate = sanitizeString(value, "");
  if (!candidate) return null;
  if (candidate.length > 128) return null;
  if (!/^[a-zA-Z0-9_-]+$/.test(candidate)) return null;
  return candidate;
};

export const sanitizeAdditionalUserData = (raw) => {
  const data = raw && typeof raw === "object" ? raw : {};
  const roles = Array.isArray(data.roles)
    ? data.roles.filter((role) => typeof role === "string")
    : [];
  const permissionsByAccount = Array.isArray(data.permissionsByAccount)
    ? data.permissionsByAccount.filter((item) => item && typeof item === "object")
    : [];

  return {
    ...data,
    roles,
    permissionsByAccount,
  };
};
